import React from 'react';
import { PalmtreeIcon } from 'lucide-react';
import { BRAND, BRAND_COMPANY, footerTagline } from '../data/resinContent';
export function Footer() {
  return <footer className="w-full border-t border-charcoal-600 bg-charcoal-900 py-14" data-id="element-159" data-mp="3ghc0pwojutll">
      <div className="mx-auto max-w-3xl px-5 text-center" data-id="element-160" data-mp="32pp764lzrz6i">
        <PalmtreeIcon className="mx-auto h-5 w-5 text-champagne" strokeWidth={1.5} aria-hidden="true" data-id="element-161" data-mp="36oo9rik93jus" />
        <p className="mt-3 font-display text-2xl font-semibold uppercase tracking-[0.2em] text-ivory-50" data-id="element-162" data-mp="3ues7xaeo6ree">
          {BRAND_COMPANY}
        </p>
        <div className="mt-4 space-y-0.5" data-id="element-163" data-mp="36msyjwt2ysh">
          {footerTagline.map(line => <p key={line} className="text-[14px] leading-relaxed text-body" data-id="element-164" data-mp="3le2jirrqo3ap">
              {line}
            </p>)}
        </div>

        <p className="mt-8 text-[11px] font-semibold uppercase tracking-[0.24em] text-champagne" data-id="element-165" data-mp="29zgli2s8ywn6">{BRAND}</p>

        <div className="mt-8 border-t border-charcoal-600 pt-8" data-id="element-166" data-mp="2eyt76k7dtxo6">
          <p className="text-[13px] leading-relaxed text-muted" data-id="element-167" data-mp="2evx8gtnpn4yo">
            © 2026 Redondo Land LLC. All rights reserved.
            <br data-id="element-168" data-mp="3gapdlka06mgi" />
            Unauthorized reproduction, resale or redistribution prohibited.
          </p>
        </div>
      </div>
    </footer>;
}